module.exports = __webpack_public_path__ + "img/o2o11.7991c1bd.png";